import { render, staticRenderFns } from "./RecipientsManual.vue?vue&type=template&id=070e99dd&scoped=true&"
import script from "./RecipientsManual.vue?vue&type=script&lang=js&"
export * from "./RecipientsManual.vue?vue&type=script&lang=js&"
import style0 from "./RecipientsManual.vue?vue&type=style&index=0&id=070e99dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070e99dd",
  null
  
)

export default component.exports